import React from 'react';
import styles from './Sidebar.module.scss';

const Sidebar = ({ children, ...props }) => {
  return (
    <nav className={styles.Sidebar} {...props}>
      {children}
    </nav>
  );
};

export default Sidebar;
